import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { AttendedECUDto } from '../dtos/attended-ECU.dto';
import { AttendedECUModel } from '../models/attended-ECU.model';
import { mapAttendedEcusDtoToAttendedEcuModel } from '../utils/mapping/mapping.util';

export const getEcusByModel = createAsyncThunk<
  AttendedECUModel[],
  number,
  Record<string, unknown>
>('firmware/getEcusByModel', async modelId => {
  const mandantId = localStorageService.get(
    LocalStorageProperties.SELECTED_MANDANT
  ) as string | null;

  const url = createPathParams<'mandantId' | 'modelId'>(
    Endpoints.GET_ECUS_BY_MODEL,
    {
      ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
      modelId,
    }
  );

  const { data }: AxiosResponse<AttendedECUDto[]> = await axiosInstance.get(
    url
  );

  return data && data.length
    ? data.map(mapAttendedEcusDtoToAttendedEcuModel)
    : [];
});
